export default {
  order_again: 'Erneut bestellen',
  error_messages: {
    product_does_not_exist: 'Das Produkt ist nicht mehr verfügbar',
  },
  success_messages: {
    product_added_to_card: 'Produkt in den Warenkorb hinzugefügt',
  },
};
